module.exports = __webpack_public_path__ + "img/bg-jeremy-pennycook.cf52e96e.jpg";